<div class="login-page">
  <div class="login-shell">
    <div class="login-hero">
      <div class="login-hero__brand">
        <img class="logo" [src]="environment.logoUrl" [alt]="environment.companyName" />
        <div class="brand-text">
          <h3 class="mb-0">{{ environment.companyName }}</h3>
          <p class="mb-0">Gestão de plantões e operações clínicas</p>
        </div>
      </div>

      <div class="login-hero__copy">
        <h2 class="mb-0">Bem-vindo(a)</h2>
        <p class="mb-0">
          Acesse seu painel para acompanhar cobertura, profissionais e escalas com mais clareza.
        </p>
      </div>

      <div class="login-hero__badges">
        <div class="badge">
          <mat-icon>health_and_safety</mat-icon>
          <span>Segurança</span>
        </div>
        <div class="badge">
          <mat-icon>schedule</mat-icon>
          <span>Plantões</span>
        </div>
        <div class="badge">
          <mat-icon>insights</mat-icon>
          <span>Indicadores</span>
        </div>
      </div>
    </div>

    <mat-card class="tagus-card login-card">
      <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

      <mat-card-header class="login-card__header">
        <div class="login-card__title w-100">
          <div class="mini-brand">
            <img class="mini-logo" [src]="environment.logoUrl" [alt]="environment.companyName" />
            <div class="mini-text">
              <div class="mini-name">{{ environment.companyName }}</div>
              <div class="mini-sub">Acesso ao painel administrativo</div>
            </div>
          </div>

          <div class="headline">
            <h4 class="mb-0">Entrar</h4>
            <p class="mb-0">Use seu e-mail e senha para acessar</p>
          </div>
        </div>
      </mat-card-header>

      <mat-card-content>
        <form [formGroup]="authForm" (ngSubmit)="onSubmit()" class="login-form">
          <div class="alert-banner" *ngIf="isLoginFailed && errorMessage">
            <mat-icon>error_outline</mat-icon>
            <span>{{ errorMessage }}</span>
          </div>

          <mat-form-field appearance="fill" class="w-100">
            <mat-label>E-mail</mat-label>
            <mat-icon matPrefix>mail</mat-icon>
            <input matInput type="email" formControlName="username" autocomplete="username" />
            <mat-error *ngIf="submitted && f['username'].hasError('required')">Informe o e-mail</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Senha</mat-label>
            <mat-icon matPrefix>lock</mat-icon>
            <input
              matInput
              [type]="hide ? 'password' : 'text'"
              formControlName="password"
              autocomplete="current-password"
            />
            <button
              type="button"
              mat-icon-button
              matSuffix
              (click)="hide = !hide"
              [disabled]="loading"
              [attr.aria-label]="hide ? 'Mostrar senha' : 'Ocultar senha'"
              [attr.aria-pressed]="!hide"
            >
              <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
            </button>
            <mat-error *ngIf="submitted && f['password'].hasError('required')">Informe a senha</mat-error>
            <mat-error *ngIf="submitted && f['password'].hasError('minlength')">Mínimo de 6 caracteres</mat-error>
          </mat-form-field>

          <div class="login-actions">
            <button
              mat-raised-button
              class="tagus login-submit"
              type="submit"
              [disabled]="loading || authForm.invalid"
            >
              <mat-icon *ngIf="!loading">login</mat-icon>
              <mat-spinner *ngIf="loading" diameter="18"></mat-spinner>
              {{ loading ? "Entrando..." : "Entrar" }}
            </button>
          </div>

          <div class="login-footer">
            <span>Ao entrar, você concorda com as políticas internas da instituição e uso adequado dos dados.</span>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>
